module.exports = __webpack_public_path__ + "er.db81cce270950a60f34f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/er.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/er.svg
// module chunks = styles